<template>
  <div class="home">
    <div class="rankings">
      <div class="profile">
        <div class="logo">
          <img src="../../assets/images/home/icon-06.png" alt="">
          <img src="../../assets/images/home/icon-05.png" alt="">
        </div>
        <div class="profile-text">
          5000+ kullanıcı burada buluşuyor! Tahmin ustaları her gün maç sonuçlarını paylaşıyor! WBBALL, futbolseverlerin
          tahmin merkezi. Ustaların profesyonel analizleriyle maç sonuçlarını kolayca tahmin et ve binlerce kullanıcıyla
          daha heyecanlı tahminler yap!
        </div>
      </div>
      <div class="rank-card">
        <div v-for="(items,index) in topRankList" :key="items.user_id">
          <div class="item" :class="index == 1?'left-moer':''" v-if="rankShow"
               :style="{ animationDelay: index * 0.5 + 's' }">
            <div class="avatrar">
              <img :src="items.user.avatar" alt="">
            </div>
            <div class="rank-info">
              <div class="rank">{{ index + 1 }}st</div>
              <div class="streak">Üst üste <span>{{ items.running_num }}</span> galibiyet</div>
              <div class="name">{{ items.user.nickname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="introduction">
      <div class="topbg">
        <div class="text-01" :class="{ 'visible': isVisible }">
          Futbol ve basketbol canlı skorları elinin altında!Futbol skorları anlık olarak güncellenir, basketbol maçları
          tam kapsamlı izlenir. Goller ve kritik anlar tek bakışta görünür, maç heyecanını her an hisset!
        </div>
      </div>
      <div class="image-01">
        <div class="score">
          <img src="../../assets/images/home/icon-010.png" alt="">
        </div>
      </div>
      <div class="text-02">
        <div class="text-02-text" :class="{ 'visible': isVisible1 }">
          Futbol tahmini + Puan ödülleriyle eğlenceyi ikiye katla! Ücretsiz puanlarla futbol tahminlerine katıl, diğer
          futbolseverlerle yarış ve hem tahmin etmenin keyfini hem de başarı hissini yaş
        </div>
        <div class="text-02-image">
          <img src="../../assets/images/home/icon-011.png" alt="">
        </div>
      </div>
      <div class="text-03" :class="{ 'visible': isVisible2 }">
        Spor haberleri modülüyle sahadaki sıcak gelişmeleri kaçırma! Her gün futbol ve basketbola dair en güncel
        haberler, transfer detayları ve derin analizlerle spordaki tüm gelişmeleri anında öğren!
      </div>
      <div class="image-02">
        <div class="detail">
          <img src="../../assets/images/home/icon-014.png" alt="">
        </div>
      </div>
      <div class="text-04" :class="{ 'visible': isVisible3 }">
        Bol ödüllü etkinlikler, puan kazanmak çok kolay!Giriş yaparak, tahmin yaparak veya etkinliklere katılarak puan
        kazan. Puanlarını istediğin hediyelerle değiştir ve izleme keyfini artır!
      </div>
      <div class="image-03">
        <div class="detail">
          <img src="../../assets/images/home/icon-015.png" alt="">
        </div>
      </div>
      <div class="text-05" :class="{ 'visible': isVisible4 }">
        Etkileşimli toplulukta senin gibi futbolseverlerle buluş! Tahminlerini paylaş, tartışmalara katıl ve dünyanın
        dört bir yanından futbol tutkunlarıyla tanış. Maç izleme keyfini bir üst seviyeye taşı!
      </div>
      <div class="image-04">
        <div class="detail">
          <img src="../../assets/images/home/icon-016.png" alt="">
        </div>
      </div>
      <div class="footer">
        <div class="footer-left">
          <div class="footer-left-image">
            <img src="../../assets/images/home/icon-06.png" alt="">
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-right-image">
            <img src="../../assets/images/home/icon-05.png" alt="">
          </div>
          <div class="footer-right-text">
            Tamamen ücretsiz bir spor platformu seni bekliyor! Ücretsiz skorlar, tahminler, haberler ve hediyelerle
            WBBALL, spor tutkunları için eşsiz bir deneyim sunuyor!
          </div>
        </div>
      </div>
    </div>
    <div class="download-btn" :class="{ visible: !isVisible11 }">
      <div class="ios" v-show="isVisible11" @click="goToIOS()">
        <img src="../../assets/images/home/ios.png" alt="">
      </div>
      <div class="android" v-show="isVisible11" @click="goToAndroid()">
        <img src="../../assets/images/home/android.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {request} from '../../api/api.js'

const crypto = require('crypto');
export default {

  name: "Home",
  data() {
    return {
      rankShow: false,
      isVisible: false,
      isVisible1: false,
      isVisible2: false,
      isVisible3: false,
      isVisible4: false,
      topRankList: [],
      isVisible11: true,
      isVisible22: false,
      web_fingerprint: '',
    };
  },
  mounted() {
    console.info(window.navigator.userAgent)
    window.addEventListener('scroll', this.handleScroll);
    if (!localStorage.getItem('WEB_FINGERPRINT')) {
      localStorage.setItem('WEB_FINGERPRINT', this.md5(this.$route.query.invite + window.screen.width + '*' + window.screen.height + Date.now() + window.navigator.userAgent))
    }
    this.getTopRank()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    md5(str) {
      const hash = crypto.createHash('md5');
      hash.update(str);
      return hash.digest('hex');
    },
    goToIOS() {
      window.open('https://apps.apple.com/us/app/wbball/id6670331171')
    },
    goToAndroid() {
      window.open('https://play.google.com/store/apps/details?id=app.wbball')
    },
    getTopRank() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let para = {
        browser_fingerprint: localStorage.getItem('WEB_FINGERPRINT'),
        invite: this.$route.params.invite,
        resolution: window.screen.width + '*' + window.screen.height,
        operating_system: isIOS?'ios':'android'
      }
      request({
        url: "/api/main/download",
        method: "get",
        params: para
      }).then((res) => {
        console.info(res)
        this.topRankList = res.data.data.rank_list
        this.rankShow = true
      });
    },
    handleSettimeOut() {
      setTimeout(() => {
        this.rankShow = true
      }, 500);
    },
    handleScroll() {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      this.isVisible11 = !(scrollPosition > 400 && (scrollPosition + windowHeight + 500) < documentHeight);
      const textElement = this.$el.querySelector('.text-01');
      const rect = textElement.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        this.isVisible = true;
      }

      const textElement1 = this.$el.querySelector('.text-02-text');
      const rect1 = textElement1.getBoundingClientRect();
      if (rect1.top < window.innerHeight && rect1.bottom > 0) {
        this.isVisible1 = true;
      }

      const textElement2 = this.$el.querySelector('.text-03');
      const rect2 = textElement2.getBoundingClientRect();
      if (rect2.top < window.innerHeight && rect2.bottom > 0) {
        this.isVisible2 = true;
      }

      const textElement3 = this.$el.querySelector('.text-04');
      const rect3 = textElement3.getBoundingClientRect();
      if (rect3.top < window.innerHeight && rect3.bottom > 0) {
        this.isVisible3 = true;
      }

      const textElement4 = this.$el.querySelector('.text-05');
      const rect4 = textElement4.getBoundingClientRect();
      if (rect4.top < window.innerHeight && rect4.bottom > 0) {
        this.isVisible4 = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  .rankings {
    height: 721px;
    background-image: url("../../assets/images/home/icon-01.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    width: 100vw;
    overflow: hidden;
    overflow-y: auto;

    .profile {

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 16px;

        img:first-child {
          width: 37.245px;
          height: 47px;
          flex-shrink: 0;
        }

        img:last-child {
          width: 107.998px;
          height: 20px;
          flex-shrink: 0;
          margin-left: 10px;
        }
      }

      .profile-text {
        width: 335px;
        color: #FFF;
        text-align: center;
        -webkit-text-stroke-color: #6C3232;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
        margin: 0 auto;
        padding: 7px 0 12px;
      }
    }

    .rank-card {
      margin-top: 260px;
      padding-bottom: 1px;
      width: 150%;
      height: 183px;

      .item {
        animation: slideIn 0.5s forwards; /* 动画名称、持续时间和方向 */
        animation-delay: 0s; /* 默认动画延迟 */
        height: 52px;
        width: 210px;
        background: linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 0, 0, 0) 100%);
        border-top-left-radius: 50px;
        border-bottom-left-radius: 50px;
        margin-bottom: 11px;
        display: flex;
        align-items: center;
        overflow: hidden;
        margin-left: 100%;

        .avatrar {
          width: 50px;
          height: 50px;
          flex-shrink: 0;
          border-radius: 50px;
          overflow: hidden;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .rank-info {
          margin-left: 5px;
          line-height: 15px;

          .rank {
            color: #F00;
            -webkit-text-stroke-color: #FFF;
            font-family: Montserrat;
            font-size: 20px;
            font-style: italic;
            font-weight: 900;
          }

          .streak {
            color: #000;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Montserrat;
            font-size: 12px;
            font-style: italic;
            font-weight: 900;
            line-height: normal;

            span {
              color: #F00;
              font-feature-settings: 'liga' off, 'clig' off;
              -webkit-text-stroke-width: 1;
              -webkit-text-stroke-color: #FFF;
              font-family: Montserrat;
              font-size: 14px;
              font-style: italic;
              font-weight: 900;
              line-height: normal;
            }
          }

          .name {
            color: #000;
            font-family: Montserrat;
            font-size: 10px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
        }
      }

      @keyframes slideIn {
        from {
          transform: translateX(0); /* 从右侧进入 */
          opacity: 0; /* 初始透明度 */
        }
        to {
          transform: translateX(-267%); /* 到达原位置 */
          opacity: 1; /* 完全不透明 */
        }
      }

      .left-moer {
        margin-left: 108%;
      }
    }
  }

  .download-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    height: 80px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    opacity: 1; /* 初始透明度 */
    transition: opacity 3s ease; /* 添加过渡效果 */


    &.visible {
      opacity: 0; /* 可见时的透明度 */
    }


    .ios {
      width: 169px;
      height: 72px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .android {
      width: 169px;
      height: 72px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .introduction {

    box-sizing: border-box;
    margin-top: -102px;

    .topbg {
      height: 220px;
      padding-top: 50px;
      background: linear-gradient(to top, rgba(255, 255, 255, 1) 70%, rgba(255, 0, 0, 0) 100%); // 设置弱化的最终点
      .text-01 {
        width: 316px;
        color: #000;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.192px;
        margin: 10px auto 0;
        padding-top: 80px;
        opacity: 0;
        filter: blur(10px);
        transform: translateY(10px);
        transition: opacity 2s ease, filter 1s ease, transform 2s ease;

        &.visible {
          opacity: 1;
          filter: blur(0);
          transform: translateY(0);
        }
      }
    }


    .image-01 {
      position: relative;
      height: 400px;
      margin-top: 24px;

      .score {
        position: absolute;
        width: 306.016px;
        height: 369px;
        left: calc(50% - 180px);
        animation: heartbeat 1.5s infinite;
        display: inline-block;
        z-index: 1;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background: rgba(234, 232, 232, 0.5);
          border-radius: 50%;
          transform: translate(-50%, -50%) scale(0);
          animation: ripple 1.5s infinite;
          z-index: -1;
        }

        img {
          height: 100%;
          width: 100%;
        }
      }

      // 定义心跳动画
      @keyframes heartbeat {
        0%, 100% {
          transform: scale(1); // 初始和结束状态
        }
        50% {
          transform: scale(1.02); // 中间状态，放大
        }
      }

      // 定义波纹动画
      @keyframes ripple {
        0% {
          transform: translate(-50%, -50%) scale(0); // 初始状态
          opacity: 1; // 初始可见
        }
        100% {
          transform: translate(-50%, -50%) scale(1.5); // 扩大到1.5倍
          opacity: 0; // 最终透明
        }
      }
    }

    .text-02 {
      height: 380px;
      background-image: url("../../assets/images/home/icon-08.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      position: relative;

      .text-02-text {
        position: absolute;
        top: 37%;
        left: 20px;
        width: 252px;
        height: 160px;
        color: #FFF;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
        letter-spacing: 0.192px;
        opacity: 0;
        filter: blur(10px);
        transform: translateY(10px);
        transition: opacity 2s ease, filter 1s ease, transform 2s ease;

        &.visible {
          opacity: 1;
          filter: blur(0);
          transform: translateY(0);
        }
      }

      .text-02-image {
        position: absolute;
        width: 340px;
        height: 480px;
        top: -120px;
        right: 0;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .text-03, .text-04, .text-05 {
      height: 90px;
      width: 327px;
      color: #000;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.213px;
      margin: 0 auto;
      opacity: 0;
      filter: blur(10px);
      transform: translateY(10px);
      transition: opacity 2s ease, filter 1s ease, transform 2s ease;

      &.visible {
        opacity: 1;
        filter: blur(0);
        transform: translateY(0);
      }
    }

    .text-04, .text-05 {
      margin-top: 30px;
    }

    .image-02, .image-03 {
      .detail {
        width: 308px;
        height: 460px;
        margin-top: 24px;
        margin-left: calc(50% - 154px);
        animation: heartbeat 1.5s infinite;
        display: inline-block;
        z-index: 1;

        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background: rgba(234, 232, 232, 0.5);
          border-radius: 50%;
          transform: translate(-50%, -50%) scale(0);
          animation: ripple 1.5s infinite;
          z-index: -1;
        }

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .image-04 {
      .detail {
        width: 350px;
        height: 347px;
        margin: 30px auto 0;

        img {
          height: 100%;
          width: 100%;
        }
      }
    }

    .footer {
      background-color: #fa2f2f;
      display: flex;
      align-items: center;
      padding: 25px 20px;
      margin-bottom: 100px;

      .footer-left {
        width: 72.906px;
        height: 92px;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .footer-right {
        flex: 1;
        margin-left: 25px;

        .footer-right-image {
          width: 95.411px;
          height: 17.668px;
          margin-bottom: 5px;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .footer-right-text {
          color: #FFF;
          font-family: Montserrat;
          font-size: 14px;
          font-style: normal;
          font-weight: 900;
          line-height: normal;
        }
      }
    }
  }
}
</style>
